// Browser Extension state on LinkedIn profile views
import Contact from '@repo/utils/models/Contact';
import { LinkedInProfileViewState, ReduxAction } from '@repo/utils/types';
import AppState from '../app-state';

export const selectLinkedInProfileView = (state: AppState): LinkedInProfileViewState =>
  state.ui.linkedinProfileView;

const initialState: LinkedInProfileViewState = {
  status: 'loading',
  contact: undefined,
  profile: undefined,
  creatingContactFromProfile: false,
  mergingProfileIntoContact: false,
  refreshingContactData: false,
};

export function linkedinProfileViewReducer(
  state: LinkedInProfileViewState = initialState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'FETCH_EXISTING_CONTACT_FOR_LINKEDIN_SLUG_REQUESTED':
      return {
        ...state,
        ...initialState,
      };

    case 'SET_LINKEDIN_PROFILE_FOR_CURRENT_URL':
      return {
        ...state,
        status: 'addToClay',
        profile: payload,
      };

    case 'GET_FULL_LINKEDIN_PROFILE':
      let nextState = {
        ...state,
        creatingContactFromProfile: payload.action === 'CREATE_CONTACT',
        mergingProfileIntoContact: payload.action === 'MERGE_INTO_CONTACT' && !payload.refresh,
        refreshingContactData: payload.action === 'MERGE_INTO_CONTACT' && payload.refresh,
      };

      return nextState;

    case 'CREATE_CONTACT_FROM_LINKEDIN_PROFILE_FAILED':
      return {
        ...state,
        creatingContactFromProfile: false,
      };

    case 'FETCH_EXISTING_CONTACT_FOR_LINKEDIN_SLUG_SUCCEEDED':
    case 'CREATE_CONTACT_FROM_LINKEDIN_PROFILE_SUCCEEDED':
    case 'MERGE_CONTACT_FROM_LINKEDIN_PROFILE_SUCCEEDED':
      return {
        ...initialState,
        status: 'clayContact',
        contact: new Contact(payload.contact),
      };

    case 'MERGE_CONTACT_FROM_LINKEDIN_PROFILE_FAILED':
      return {
        ...state,
        mergingProfileIntoContact: false,
      };

    default:
      return state;
  }
}
